import React from "react";
import {Button, Col} from "react-bootstrap";
import {useNavigate} from 'react-router-dom';

const SectionThree = () => {
    const navigate = useNavigate();
    return (

        <div id="id_voice" className="overflow-hidden">
            {/*<div id="products" className="dot-background">*/}

            {/*</div>*/}
            <Col lg={7} className="mx-auto text-center overflow-hidden" style={{'margin-top' : '5%'}}>
                <p className="mx-2 px-2 mb-5 display-5 fw-normal">
                    <strong className="gradient-text">VOICE</strong> <br />
                </p>
                <p className="gradient-text" style={{ fontSize : "large", fontWeight : "bolder"}}>Global connectivity designed for scale, quality and reliability</p>

                {/*<Button onClick={() => navigate('/contact')} className="gradient-border-button-learn">Learn*/}
                {/*    More</Button>*/}
            </Col>
        </div>
    );
};

export default SectionThree;
